module.exports = __webpack_public_path__ + "static/media/frames_Q6D.86ef088b.png";